"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ClearableInput = _interopRequireDefault(require("../clearableInput/ClearableInput"));
var TableSearch = function TableSearch(props) {
  var className = props.className;
  var wrapperClassNames = (0, _classnames["default"])('table-toolbar-search', 'input-group', className && className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "input-group-addon"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-search"
  })), /*#__PURE__*/_react["default"].createElement(_ClearableInput["default"], props));
};
TableSearch.defaultProps = {};
TableSearch.propTypes = {
  className: _propTypes["default"].string
};
var _default = TableSearch;
exports["default"] = _default;